export default __webpack_public_path__ + "static/media/RobotoMono-Regular.501d7ceb.woff2";